import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logoImg from "../Images/logo.jpeg";



import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Header = () => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("Home");

  // menu open ho to body scroll band
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  const handleNav = (name, path) => {
    setActive(name);
    navigate(path);
    setOpen(false);
  };

  return (
    <>
      {/* TOP BLUE BAR */}
      <div className="top-blue-bar">
        <div className="container d-flex justify-content-between align-items-center">

          {/* LEFT INFO */}
          <div className="d-flex align-items-center gap-4">
            <span className="d-flex align-items-center gap-2">
              <FaPhoneAlt /> +9415481386
            </span>

            <span className="d-flex align-items-center gap-2">
              <FaEnvelope /> babaindustries69@gmail.com
            </span>

            <span className="d-flex align-items-center gap-2">
              <FaMapMarkerAlt /> Kanpur Dehat (U.P.)-209112
            </span>
          </div>

          {/* RIGHT SOCIAL */}
          <div className="d-flex align-items-center gap-3">
            <span className="fw-semibold">Follow Us On :</span>
            <a href="https://www.facebook.com/profile.php?id=100051519532109" className="social-icon"><FaFacebookF /></a>
            <a href="https://www.instagram.com/invites/contact/?utm_source=ig_contact_invite&utm_medium=copy_link&utm_content=v2w6e3n" className="social-icon"><FaInstagram /></a>
             {/* <a href="#" className="social-icon"><FaTwitter /></a> */}
          </div>
        </div>
      </div>

      {/* NAVBAR */}
      <section className="navbar sticky-top bg-white shadow-sm">
        <div className="container d-flex justify-content-between">

          {/* LOGO */}
   <img
  src={logoImg}
  alt="Baba Industries Logo"
  className="navbar-brand"
  style={{
    height: "4.5em",
    // width:"auto",
    cursor: "pointer",
    objectFit: "contain",
  }}
  onClick={() => handleNav("Home", "/")}
/>


          {/* DESKTOP MENU */}
          <ul className="nav d-none d-lg-flex gap-4 mb-0 fw-bold">
            {["Home", "About", "Our Range", "Contact"].map((item) => (
              <li
                key={item}
                className={`nav-item ${
                  active === item ? "text-primary" : "text-dark"
                }`}
                onClick={() =>
                  handleNav(
                    item,
                    item === "Home"
                      ? "/"
                      : item == 'Our Range' ? '/range' : `/${item.toLowerCase().replace(" ", "")}`
                  )
                }
              >
                {item}
              </li>
            ))}
          </ul>

          {/* DESKTOP BUTTON */}
          <button
            className="btn btn-outline-primary rounded-pill d-none d-lg-block"
            onClick={() => navigate('tel:9415481386')}
          >
            Get Free Quote
          </button>

          {/* MOBILE TOGGLER */}
          <button
            className="navbar-toggler d-lg-none"
            onClick={() => setOpen(true)}
          >
            ☰
          </button>
        </div>
      </section>

      {/* MOBILE OVERLAY MENU */}
      <div className={`mobile-overlay ${open ? "show" : ""}`}>
        <div className="mobile-menu-box">
  <img
  src={logoImg}
  alt="Baba Industries Logo"
  className="navbar-brand"
  style={{
    height: "80px",
    cursor: "pointer",
    objectFit: "contain",
  }}
  onClick={() => handleNav("Home", "/")}
/>

          <button className="close-btn" onClick={() => setOpen(false)}>
            ✕
          </button>

          <ul className="list-unstyled text-center mt-5 fw-bold">
            {["Home", "About", "Our Range", "Contact"].map((item) => (
              <li
                key={item}
                className={`mb-3 ${
                  active === item ? "text-primary" : ""
                }`}
                onClick={() =>
                  handleNav(
                    item,
                    item === "Home"
                      ? "/"
                      : item == 'Our Range' ? '/range' : `/${item.toLowerCase().replace(" ", "")}`
                  )
                }
              >
                {item}
              </li>
            ))}
          </ul>

          <button
            className="btn btn-primary rounded-pill w-100 mt-4"
            onClick={() => navigate('tel:9415481386')}
          >
            Get Free Quote
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
